import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { type AddressSuggestion, fetchAddressDetails, fetchAddressSuggestions } from "../../../api/fetchAddress";
import { useSalesContext } from "../../../sales-context/SalesContext";

const NO_SUGGESTIONS: readonly AddressSuggestion[] = Object.freeze([]);

export const useAddressSearch = (searchText: string, isEnabled = true) => {
    const { logger, apiClients } = useSalesContext();
    // Google bills the searches and the details call that follows them as one session, and the details call ends
    // it. The token rotates as that call goes out, so a search typed while it's in flight starts the next session.
    const sessionToken = useRef(crypto.randomUUID());

    const { data: suggestions = NO_SUGGESTIONS, isLoading } = useQuery({
        queryKey: ["address-lookup", searchText],
        queryFn: async () => fetchAddressSuggestions(apiClients.sales, logger, searchText, sessionToken.current),
        retry: false,
        enabled: isEnabled,
    });

    const resolveAddress = async (placeId: string) => {
        const endingToken = sessionToken.current;
        sessionToken.current = crypto.randomUUID();
        return fetchAddressDetails(apiClients.sales, logger, placeId, endingToken);
    };

    return { suggestions, isLoading, resolveAddress };
};
